export function debounce<T extends unknown[], U>(
  callback: (...args: T) => PromiseLike<U> | U,
  wait: number
) {
  let timer: number

  const cancel = () => window.clearTimeout(timer)
  const result = (...args: T) => {
    cancel()

    return new Promise<U>((resolve) => {
      timer = window.setTimeout(() => resolve(callback(...args)), wait)
    })
  }

  result.cancel = cancel

  return result
}
